export default __webpack_public_path__ + "static/media/device_health_monitoring_icon.5ce389f2.svg";